//const BaseGUrl = "http://172.20.0.18";
//const BaseGUrl = "http://172.20.0.23";
//const BaseGUrl = "http://178.252.183.74";
//const BaseGUrl = "http://178.252.183.78:8000";
const BaseGUrl = "https://api.digitalagahi.ir";
//const BaseGUrl = "http://localhost:8000";
const HttpUrl = "http://178.252.183.74:805";
const MessagingUrl = "https://messaging.x.com";
//const BaseGUrl = "http://172.20.3.81:30019";

//const GURL = `${BaseGUrl}:8000/api`;
const GURL = `${BaseGUrl}/api`;

export { GURL, BaseGUrl, HttpUrl, MessagingUrl };
